import customHistory from 'customHistory';

export const getPageTitle = () => {
  const { pathname } = customHistory.location;
  if (/accounts\/[0-9]+/.test(pathname)) return 'Account history';
  if (/accounts\/[0-9]+\/[0-9]+/.test(pathname)) return 'Order details';
  switch (pathname) {
    case '/':
      return 'Home';
    case '/accounts':
      return 'Accounts';
    case '/profile':
      return 'My profile';
    default:
      return '';
  }
};
